function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { DatePicker, Space, Table, Descriptions, message, Button, Divider, Form, Select } from "antd";
import { Container, Row, Col } from "react-bootstrap";
import { Excel } from "antd-table-saveas-excel";
import { Col as AntCol, Row as AntRow } from "antd";
import moment from "moment";
import { Download, Cash, BuildingFill, BuildingFillGear } from "react-bootstrap-icons";
import Common from "./includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;

var InsBills = function InsBills() {
  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      listOfBills = _useState2[0],
      setListOfBills = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      billsArrayData = _useState4[0],
      setBillsArrayData = _useState4[1];

  var _useState5 = useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      isDataLoading = _useState6[0],
      setIsDataLoading = _useState6[1];

  var _useState7 = useState(moment().startOf('month').format()),
      _useState8 = _slicedToArray(_useState7, 2),
      from = _useState8[0],
      setFrom = _useState8[1];

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      selectedCompanyId = _useState10[0],
      setSelectedCompanyId = _useState10[1];

  var _useState11 = useState([]),
      _useState12 = _slicedToArray(_useState11, 2),
      companyList = _useState12[0],
      setCompanyList = _useState12[1];

  var _useState13 = useState(moment().endOf('month').format()),
      _useState14 = _slicedToArray(_useState13, 2),
      to = _useState14[0],
      setTo = _useState14[1];

  var _useState15 = useState(null),
      _useState16 = _slicedToArray(_useState15, 2),
      company = _useState16[0],
      setCompany = _useState16[1];

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var onSearchFinish = function onSearchFinish(values) {
    setListOfBills([]);
    setBillsArrayData([]);
    setFrom(moment(new Date(values.range[0]._d)).format());
    setTo(moment(new Date(values.range[1]._d)).format());
    setSelectedCompanyId(values.company_id);
  };

  var rangePresets = {
    "Aujourdh'ui": [moment().startOf('day'), moment().endOf('day')],
    'Cette semaine': [moment().startOf('week'), moment().endOf('week')],
    'Ce mois': [moment().startOf('month'), moment().endOf('month')]
  };
  var cols = [{
    title: "Entreprise",
    dataIndex: "company",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        style: {
          textTransform: "uppercase"
        },
        children: text
      });
    },
    key: "company"
  }, {
    title: "Date prestation",
    dataIndex: "date",
    render: function render(date) {
      return /*#__PURE__*/_jsx("b", {
        children: date
      });
    },
    key: "date"
  }, {
    title: "Assuré principal",
    dataIndex: "patient",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "patient"
  }, {
    title: "Bénéficiaire",
    dataIndex: "beneficiary",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "beneficiary"
  }, {
    title: "Acte (s)",
    dataIndex: "acte",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "acte"
  }, {
    title: "Total (GNF)",
    dataIndex: "total",
    key: "total"
  }, {
    title: "Part assuré",
    dataIndex: "patient_part",
    key: "patient_part"
  }, {
    title: "Part assureur",
    dataIndex: "company_part",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "company_part  "
  }];

  var handleExport = function handleExport() {
    var excel = new Excel();
    excel.addSheet("sheet").addColumns(cols).addDataSource(billsArrayData, {
      str2Percent: true
    }).saveAs(from + "-" + to + ".xlsx");
  };

  useEffect(function () {
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + "getinsbills/" + moment(new Date(from)).format() + "/" + moment(new Date(to)).format() + "/" + selectedCompanyId + "/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setListOfBills(response.data.billsdata);
        setCompany(response.data.company);
        var totalDue = 0;
        response.data.billsdata.forEach(function (d) {
          var iar = [];
          d.bills.forEach(function (i) {
            i.bill_items.forEach(function (e) {
              if (e.business_account_medical_item != null) iar.push(e.business_account_medical_item.label);
              totalDue += e.business_account_medical_item.base_price;
            });
            setBillsArrayData(function (prev) {
              return [].concat(_toConsumableArray(prev), [{
                key: i.id,
                company: d.label,
                date: new Date(i.created_at).toLocaleDateString("Fr"),
                patient: i.customer.firstname + " " + i.customer.lastname,
                beneficiary: i.customer.insnumber,
                acte: iar.join(", "),
                total: i.total_amount.toLocaleString("Fr"),
                patient_part: i.patient_part.toLocaleString("Fr"),
                company_part: i.company_part != null ? i.company_part.toLocaleString("Fr") : 0
              }]);
            });
          });
        });

        if (response.data.company != null) {
          var com_amount = totalDue * response.data.company.commercial_rate * 0.01;
          var tbp_amount = totalDue - com_amount;
          var tax_amount = tbp_amount * response.data.company.tax_rate * 0.01;
          var final_amount = tbp_amount - tax_amount;
          setBillsArrayData(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: "b1",
              patient_part: "TOTAL (GNF)",
              company_part: totalDue.toLocaleString("Fr")
            }]);
          });
          setBillsArrayData(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: "b2",
              patient_part: "REMISE -" + response.data.company.commercial_rate.toString() + "%",
              company_part: com_amount.toLocaleString("Fr")
            }]);
          });
          setBillsArrayData(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: "b3",
              patient_part: "NET A PAYER (GNF) ",
              company_part: tbp_amount.toLocaleString("Fr")
            }]);
          });
          setBillsArrayData(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: "b4",
              patient_part: "TAXE/RETENUE (GNF) - " + response.data.company.tax_rate.toString() + "%",
              company_part: tax_amount.toLocaleString("Fr")
            }]);
          });
          setBillsArrayData(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: "b5",
              patient_part: "NET A PAYER (GNF)",
              company_part: final_amount.toLocaleString("Fr")
            }]);
          });
        }
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenuee",
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
    axios.get(Common.baseApiUrl + 'geticompanylist').then(function (response) {
      setIsDataLoading(false);

      if (response.data.status == 200 && response.data.iclist.length > 0) {
        setCompanyList([]);
        response.data.iclist.forEach(function (ic) {
          setCompanyList(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: ic.label,
              value: ic.id
            }]);
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    });
  }, [from, to, selectedCompanyId]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          children: [/*#__PURE__*/_jsx(Form, {
            form: form,
            size: "large",
            onFinish: onSearchFinish,
            layout: "horizontal",
            children: /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 4,
                sm: 12,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "company_id",
                  rules: [{
                    required: true,
                    message: "Choisir une entreprise"
                  }],
                  children: /*#__PURE__*/_jsx(Select, {
                    placeholder: "Choisir une assurance",
                    options: companyList
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 4,
                md: 5,
                sm: 12,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "range",
                  rules: [{
                    required: true,
                    message: "Champs obligatoire"
                  }],
                  children: /*#__PURE__*/_jsx(RangePicker, {
                    ranges: rangePresets,
                    showTime: {
                      format: 'HH:mm'
                    },
                    format: "DD-MM-YYYY HH:mm"
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 4,
                md: 3,
                sm: 12,
                children: /*#__PURE__*/_jsxs(Space, {
                  direction: "horizontal",
                  children: [/*#__PURE__*/_jsx(Form.Item, {
                    children: /*#__PURE__*/_jsx(Button, {
                      disabled: companyList.length == 0,
                      type: "primary",
                      htmlType: "submit",
                      children: /*#__PURE__*/_jsx("b", {
                        children: "RECHERCHE"
                      })
                    })
                  }), /*#__PURE__*/_jsx(Form.Item, {
                    children: /*#__PURE__*/_jsx(Button, {
                      type: "primary",
                      onClick: handleExport,
                      style: {
                        background: "#34C482"
                      },
                      icon: /*#__PURE__*/_jsx(Download, {
                        size: 28
                      }),
                      children: /*#__PURE__*/_jsx("b", {
                        children: "EXPORTER"
                      })
                    })
                  })]
                })
              })]
            })
          }), /*#__PURE__*/_jsx(Divider, {}), listOfBills && listOfBills.length > 0 && /*#__PURE__*/_jsx(_Fragment, {
            children: /*#__PURE__*/_jsxs("div", {
              className: "cool-radius white-bg",
              style: {
                padding: '40px'
              },
              children: [/*#__PURE__*/_jsxs(AntRow, {
                children: [/*#__PURE__*/_jsx(AntCol, {
                  span: 6,
                  children: /*#__PURE__*/_jsx("img", {
                    src: "drawables/logo_sos.jpeg",
                    style: {
                      width: '130px'
                    }
                  })
                }), /*#__PURE__*/_jsx(AntCol, {
                  span: 6
                })]
              }), /*#__PURE__*/_jsx(AntRow, {
                children: /*#__PURE__*/_jsxs(AntCol, {
                  span: 6,
                  offset: 18,
                  children: [/*#__PURE__*/_jsxs("div", {
                    style: {
                      fontWeight: "bold",
                      fontStyle: 'italic'
                    },
                    children: ["Du ", new Date(from).toLocaleDateString("Fr"), " Au ", new Date(to).toLocaleDateString("Fr")]
                  }), /*#__PURE__*/_jsx("h4", {
                    children: company && company.label
                  })]
                })
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(AntRow, {
                children: /*#__PURE__*/_jsx(AntCol, {
                  span: 24,
                  children: /*#__PURE__*/_jsx(Table, {
                    size: "small",
                    columns: cols,
                    bordered: true,
                    sticky: true,
                    loading: isDataLoading,
                    dataSource: billsArrayData,
                    scroll: {
                      y: 820
                    },
                    pagination: false
                  })
                })
              })]
            })
          })]
        })
      })
    })
  });
};

export default InsBills;